"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BadgeType = exports.BadgeColorScheme = void 0;
// export enum BadgeVariant {
//   Dot = 'dot',
//   Icon = 'icon',
//   Text = 'text'
// }
var BadgeType;
exports.BadgeType = BadgeType;

(function (BadgeType) {
  BadgeType["Default"] = "default";
  BadgeType["Primary"] = "primary";
  BadgeType["Neutral"] = "neutral";
  BadgeType["Positive"] = "positive";
  BadgeType["Warning"] = "warning";
  BadgeType["Negative"] = "negative";
})(BadgeType || (exports.BadgeType = BadgeType = {}));

var BadgeColorScheme;
exports.BadgeColorScheme = BadgeColorScheme;

(function (BadgeColorScheme) {
  BadgeColorScheme["Default"] = "default";
  BadgeColorScheme["DarkBackground"] = "darkBackground";
})(BadgeColorScheme || (exports.BadgeColorScheme = BadgeColorScheme = {}));